import { z } from "zod";
// ------------------------------------------------------------------
// Respuestas (lo que el backend REALMENTE devuelve). Sin montos
// Decimal en este módulo, así que no hace falta z.coerce.number().
// ------------------------------------------------------------------
export const MetricasInstaladorSchema = z.object({
    totalSucursales: z.number(),
    totalMesas: z.number(),
    totalImpresoras: z.number(),
    totalUsuarios: z.number(),
    totalCategorias: z.number(),
});
export const EstadoInstaladorRespuestaSchema = z.object({
    appNode: z.string(),
    dbStatus: z.string(),
    inicializado: z.boolean(),
    error: z.string().optional(),
    sucursal: z
        .object({
        id: z.string(),
        nombre: z.string(),
        direccion: z.string().nullable().optional(),
        telefono: z.string().nullable().optional(),
    })
        .nullable()
        .optional(),
    metricas: MetricasInstaladorSchema,
});
export const VincularSucursalRespuestaSchema = z.object({
    exito: z.boolean(),
    mensaje: z.string(),
    vinculadoEn: z.string().optional(),
});
export const DiagnosticoImpresoraRespuestaSchema = z.object({
    id: z.string(),
    nombre: z.string(),
    ip: z.string(),
    puerto: z.number(),
    online: z.boolean(),
    mensaje: z.string(),
});
// Publicada por la nube (pública, sin auth) para que cualquier nodo local
// pueda revisar si hay una versión más nueva del instalador de Windows.
export const VersionInstaladorRespuestaSchema = z.object({
    publicada: z.boolean(),
    version: z.string().nullable(),
    notas: z.string().nullable(),
    fecha: z.string().nullable(),
    urlDescarga: z.string().nullable(),
});
// Lo que ve el nodo LOCAL al comparar su propia versión contra la de la nube.
export const VerificarActualizacionRespuestaSchema = z.object({
    versionActual: z.string(),
    versionDisponible: z.string().nullable(),
    hayActualizacion: z.boolean(),
    notas: z.string().nullable(),
    urlDescarga: z.string().nullable(),
});
//# sourceMappingURL=instalador.schema.js.map